export const PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 1000;

export const DATA_TABLE_PAGE_SIZE_KEY = 'DATA_TABLE_PAGE_SIZE';
export const PAGE_SIZES = [25, 50, 100, 200];
